let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:

    (lib.Symbol8 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E7E7E7')
            .s()
            .p('AiwghIFgjLIABENIlgDMg');
        this.shape.setTransform(5.8, 3.4);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('Ag5BlIgBkNIB0BDIABEOg');
        this.shape_1.setTransform(-17.6, 10.2);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#FFFFFF')
            .s()
            .p('AjqBEIFgjLIB1BEIlgDLg');
        this.shape_2.setTransform(0, -13.5);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-23.5, -27.1, 47, 54.2);

    (lib.Symbol7 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('Ag3BdIgFj9IB4A0IABENg');
        this.shape.setTransform(-0.1, -2.4);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-6.2, -18.5, 12.2, 32.2);

    (lib.Symbol6 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E7E7E7')
            .s()
            .p('AnVDMIM2naIB1BDIs2Hbg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-47, -27.1, 94, 54.3);

    (lib.Symbol5 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AmbAjIM2naIABGVIh1BDIgBkNIpMFSIABEOIh1BEg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-41.2, -44, 82.4, 88.1);

    (lib.Symbol4 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E7E7E7')
            .s()
            .p('AtYD0IUlrcIGMDnI0MLqg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-85.7, -48.8, 171.5, 97.8);

    (lib.Symbol3 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AqGCrIUMrqIABGVI0MLqg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-64.7, -57.6, 129.5, 115.3);

    (lib.Symbol2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('Ag5CpIgBmUIB0BDIABGVg');
        this.shape.setTransform(-15.9, -20.2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('AjSBPIAAmTIGkD1IABGUg');
        this.shape_1.setTransform(-39.4, 31.8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-60.5, -43.8, 50.5, 108.2);

    // stage content:
    (lib._5 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_2
        this.instance = new lib.Symbol8('synched', 0);
        this.instance.parent = this;
        this.instance.setTransform(12.3, 148.9, 1, 1, -2.5, 0, 0, -113.4, 27.1);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({y: 168.9}, 4)
                .wait(42)
                .to({startPosition: 0}, 0)
                .to({y: 148.9}, 4)
                .wait(10)
        );

        // Layer_10
        this.instance_1 = new lib.Symbol3('synched', 0);
        this.instance_1.parent = this;
        this.instance_1.setTransform(118.9, 103.3);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({regX: 0.2, regY: 0.1, scaleX: 1.05, scaleY: 1.01, skewX: -9, skewY: 0.9, x: 115.8, y: 97.6}, 16)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({regX: 0, regY: 0, scaleX: 1, scaleY: 1, skewX: 0, skewY: 0, x: 118.9, y: 103.3}, 10)
                .wait(16)
        );

        // Layer_7
        this.instance_2 = new lib.Symbol5('synched', 0);
        this.instance_2.parent = this;
        this.instance_2.setTransform(103.6, 56);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({scaleX: 1.01, scaleY: 1.01, skewX: -8.8, skewY: 3.5, x: 90.7, y: 51.2}, 16)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({scaleX: 1, scaleY: 1, skewX: 0, skewY: 0, x: 103.6, y: 56}, 10)
                .wait(16)
        );

        // Layer_11
        this.instance_3 = new lib.Symbol7('synched', 0);
        this.instance_3.parent = this;
        this.instance_3.setTransform(127.4, 45.5);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_3)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({scaleX: 0.93, scaleY: 0.97, skewX: -4.8, skewY: -20.1, x: 115.3, y: 44.8}, 16)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({scaleX: 1, scaleY: 1, skewX: 0, skewY: 0, x: 127.4, y: 45.5}, 10)
                .wait(16)
        );

        // Layer_4
        this.instance_4 = new lib.Symbol2('synched', 0);
        this.instance_4.parent = this;
        this.instance_4.setTransform(12, 136.4, 1, 1, 0, 0, 0, -60.5, 39.8);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_4)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({rotation: -9}, 16)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({rotation: 0}, 10)
                .wait(16)
        );

        // Layer_5
        this.instance_5 = new lib.Symbol6('synched', 0);
        this.instance_5.parent = this;
        this.instance_5.setTransform(97.7, 32.3);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_5)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({regX: 0.1, regY: 0.2, scaleX: 0.93, skewY: 1.9, x: 81.4, y: 29}, 16)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({regX: 0, regY: 0, scaleX: 1, skewY: 0, x: 97.7, y: 32.3}, 10)
                .wait(16)
        );

        // Layer_9
        this.instance_6 = new lib.Symbol4('synched', 0);
        this.instance_6.parent = this;
        this.instance_6.setTransform(97.8, 71.5);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_6)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({regX: 0.2, regY: 0.4, scaleX: 0.98, scaleY: 0.9, skewY: -3.5, x: 90.2, y: 69.8}, 16)
                .wait(9)
                .to({startPosition: 0}, 0)
                .to({regX: 0, regY: 0, scaleX: 1, scaleY: 1, skewY: 0, x: 97.8, y: 71.5}, 10)
                .wait(16)
        );

        // Слой 1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('AjTBPIAAmUIGlD2IACGVg');
        this.shape.setTransform(33.2, 182.4);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#9AA5C0')
            .s()
            .p('AqHCrIUOrqIAAGVI0MLqg');
        this.shape_1.setTransform(119, 157.3);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#6B6E8E')
            .s()
            .p('AtZDOIU+qSIF1CfI0MLqg');
        this.shape_2.setTransform(97.8, 115.7);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#FFFFFF')
            .s()
            .p('AjSg3IAAiHIGlD2IAACHg');
        this.shape_3.setTransform(33.1, 155.4);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#E7E7E7')
            .s()
            .p('AqGEyIUMrqIABCHI0NLqg');
        this.shape_4.setTransform(119, 130.3);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(60)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(109.5, 113.2, 171.8, 209.8);
    // library properties:
    lib.properties = {
        id: 'AF8AB0DAF1574FA2BA6346E3AD155A1C',
        width: 195,
        height: 216,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['AF8AB0DAF1574FA2BA6346E3AD155A1C'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('AF8AB0DAF1574FA2BA6346E3AD155A1C');

export {AdobeAn};
export {composition};
